<template>
  <!-- 商品列表切版畫面 -->
  <div :class="$style.wrapper">
    <div :class="$style.table">
      <template>
        <div :class="$style.goodsListClass">
          <el-button class="is-round" style="margin-bottom: 20px" @click="$emit('backToItemHome')">
            <BaseIcon name="arrow-left" />
            返回項目首頁
          </el-button>
          <h5>商品列表</h5>
        </div>
      </template>

      <el-tabs v-model="activeName" stretch @tab-click="handleClick">
        <el-tab-pane label="全部商品" name="allGoods" class="pageHeader">
          <el-page-header v-if="pageHeaderShow" :title="selectTitle" style="margin-top: 20px;margin-bottom: 20px;"
            @back="backToCategory"></el-page-header>
          <div :class="$style.subTitleDisplay">
            <el-button v-if="thisTimeCategoryTitle.length > 0" size="small" :class="[$style.backBtn, $style.btnNoStyle]"
              @click="backToInfo">
              <i class="fa fa-angle-left fa-icon" aria-hidden="true"></i>
            </el-button>
            <h4>{{ thisTimeCategoryTitle }}</h4>
          </div>

          <el-input v-model="goodsName" :placeholder="'搜尋商品名稱'" style="margin-bottom: 20px;" class="is-border bg-white">
            <i slot="suffix" style="cursor: pointer" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-select v-model="filterLabel" style="margin-bottom: 20px;">
            <el-option label="只匯出訂單資訊" value="byOrder"></el-option>
            <el-option label="匯出訂單資訊與參與人資訊" value="byPerson"></el-option>
          </el-select>
          <div :class="$style.innerWrapper">
            <div :class="$style.innerTable">

              <!-- 類別 -->
              <div v-if="type === 'category'" :class="$style.categoryDivDisplay">
                <div v-for="(category, index) in currentList" :key="index" class="categoryDiv"
                  @click="goNextCategory(category)">
                  {{ category.title }}
                </div>
              </div>

              <!-- 商品 -->
              <div v-if="type === 'product'" :class="$style.categoryDivDisplay">
                <div v-for="(product, index) in productList" :key="index" class="categoryDivForThree"
                  @click="showSpecDialog(product, '', 'popWindow')">
                  <img v-if="product.image" :class="$style.imgHeight" class="img" :src="product.image" />
                  <img v-else class="img" :class="$style.imgHeight"
                    :src="require(`@assets/images/icons/face-cream.svg`)" />
                  <div class="textDisplay">
                    <p class="title">{{ product.title }}</p>
                    <p class="subTitle">{{ product.petCategoryTitle }}</p>
                    <!-- <p class="price">NT$ 999</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="掃描條碼" name="scan">
          <div :class="$style.commodityTopLeftBtn">
            <template>
              <el-select value="1" placeholder="商品名稱" :class="$style.commodityTopLeftBtn__select">
                <el-option label="商品名稱" value="1"></el-option>
                <el-option label="商品貨號" value="2"></el-option>
              </el-select>
              <el-input placeholder="搜尋商品完整貨號" :class="$style.commodityTopLeftBtn__input">
                <i slot="suffix" class="el-icon-search el-input__icon" @click="handleIconClick"> </i>
              </el-input>
            </template>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 開啟加入商品跳窗 -->
    <el-dialog :visible.sync="addGoodsDialogShowStatus" width="550px" top="0" left="0" title="選擇款式"
      :close-on-click-modal="false" append-to-body>
      <div :class="$style.centerText">{{ selectedProduct.title }}</div>
      <el-form class="el-form-item--normal-margin el-form--label-top">
        <el-form-item v-for="(item, index) in spec" :key="`spec${index}`" :label="item.title"
          class="el-form-item--white-bg">
          <div :class="$style.specDetailDisplay">
            <div v-for="(innerItem, innerIndex) in item.values" :key="innerIndex"
              :class="{ [$style.specDetailDisplay__innerDiv]: true, [$style.selectedSpec]: selectedSpecFunc(index, innerIndex) }"
              @click="selectSpec(index, innerIndex)">
              <!-- <p>{{ innerItem.title }} {{ index }} {{ innerIndex }}</p> -->
              <p>{{ innerItem.title }}</p>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="數量" class="el-form-item--white-bg" :class="$style.counter">
          <el-input-number v-model="num" @change="handleChange"></el-input-number>
        </el-form-item>
      </el-form>
      <p>{{ computedPetSizesPrice.prices[0].price }}</p>
      <div>
        <el-button class="is-round is-fullwidth" :disabled="selectedIndexSpecArr.length !== spec.length" type="primary"
          @click="addToGoodsList">加入訂單</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'GoodsList',
  props: {
    locationValue: {
      type: String,
      require: true,
      default: ''
    }
  },
  data() {
    return {
      addGoodsDialogShowStatus: false, // 選擇款式的彈窗
      num: 1, // 選擇款式的商品跳窗數量
      goodsName: '', // 商品名稱
      activeName: 'allGoods', // 頁籤名稱
      filterLabel: '', // 過濾標籤
      selectedIndexSpecArr: [], // 選到的規格
      selectedDetailSpecArr: [], // 選到的規格
      showControl: {
        category1: true,
        category2: false,
        category3: false,
      },

      type: 'category',
      categoryList: [],
      currentList: [],
      productList: [],
      spec: [],
      thisTimeCategoryTitle: '', // 這次選擇到的categoryTitle
      selectedProduct: {}, // 此次選到的product
    }
  },

  computed: {
    selectTitle() {
      return '保養'
    },
    /**
     * @description header show的條件：category1 true：則不顯示
     */
    pageHeaderShow() {
      if (this.showControl['category1']) {
        return false
      } else {
        return true
      }
    },
    /**
     * @description 選擇到的規格的價格
     */
    computedPetSizesPrice() {
      if (this.spec.length === this.selectedIndexSpecArr.length && this.spec.length !== 0 && this.selectedIndexSpecArr !== 0) {
        let selectedPetSize = {}
        let resultTextArr = []
        this.selectedIndexSpecArr.forEach(selectedIndexSpecItem => {
          const fMatch = selectedIndexSpecItem.match(/([f])(\d+)/);
          const pMatch = selectedIndexSpecItem.match(/([p])(\d+)/);
          let fMatchNum = +fMatch[2]
          let pMatchNum = +pMatch[2]
          resultTextArr.push(`${this.spec[fMatchNum].title}${this.spec[fMatchNum].alias}:${this.spec[fMatchNum].values[pMatchNum].title}${this.spec[fMatchNum].values[pMatchNum].alias}`)
        })
        if ('petSizes' in this.selectedProduct) {
          this.selectedProduct.petSizes.forEach(petSize => {
            if (this.isSameSpec(petSize.spec_tag, resultTextArr) && petSize.productId === this.locationValue) {
              selectedPetSize = petSize
              this.$set(selectedPetSize, 'priceId', selectedPetSize.prices[0].id)
              this.$set(selectedPetSize, 'title', this.selectedProduct.title)
              this.$set(selectedPetSize, 'type', 'goods')
              this.$set(selectedPetSize, 'qty', this.num)
              this.$set(selectedPetSize, 'price', selectedPetSize.prices[0].price)
            }
          })
        }
        return selectedPetSize
      } else {
        return {
          prices: [{
            price: 0
          }]
        }
      }
    },
  },
  mounted() {
    this.getCategoryList()
    this.getProductList('36')
  },
  methods: {
    /**
     * @description 看兩個spec 是否相同
     */
    isSameSpec(specTagText, resultText) {
      let specTagArr = specTagText.split(',')
      if (specTagArr.length !== resultText.length) {
        return false;
      }

      // 使用 every 方法检查所有元素是否在另一个数组中存在
      return specTagArr.every(element => resultText.includes(element));
    },
    /**
     * @description 返回初始分類
     */
    async backToInfo() {
      await this.getCategoryList()
      this.type = 'category'
      this.thisTimeCategoryTitle = ''
    },
    async getCategoryList() {
      this.categoryList = await this.$store.dispatch('product/fetchServiceCategoryForLeaf', {
        type: 'goods',
        onlyLeaf: 0,
      })
      this.currentList = this.categoryList
    },
    async getProductList(id) {
      let res = await this.$store.dispatch('product/fetchNormalServiceData', {
        types: ['goods'],
        petCategoryId: id,
      })
      console.log(res.items)
      this.productList = res.items
    },
    /**
     * @description 前往下一個類別
     */
    async goNextCategory(category) {
      this.thisTimeCategoryTitle = category.categoryTitle
      if (this.isLastCategory(category)) {
        await this.getProductList(category.id)
        this.type = 'product'
      } else {
        this.currentList = category.children
      }
    },
    isLastCategory(category) {
      return category.children.length === 0
    },
    showSpecDialog(product, cNumber, popStatus) {
      this.selectedProduct = product
      console.log("🚀 ~ file: GoodsList.vue:189 ~ showSpecDialog ~ this.selectedProduct:", this.selectedProduct)
      this.spec = product.spec
      if (popStatus && popStatus === 'popWindow') {
        this.toPopWindow()
        return
      }
      if (cNumber.length > 0) {
        this.showControlFunc(cNumber)
      }
    },

    /**
     * @description 點選規格，放入點選表中
     */
    selectSpec(index, innerIndex) {
      try {
        const clickIndex = `f${index}p${innerIndex}`
        if (!this.selectedIndexSpecArr.includes(clickIndex)) {
          const pIndex = `f${index}`
          this.selectedIndexSpecArr = this.selectedIndexSpecArr.filter((item) => !item.includes(pIndex))
          this.selectedIndexSpecArr.push(clickIndex)
        } else {
          this.selectedIndexSpecArr = this.selectedIndexSpecArr.filter((item) => item !== clickIndex)
        }
        console.log(this.spec)
        console.log(this.selectedIndexSpecArr)
      } catch (error) {
        console.error(error.message)
      }
    },
    handleIconClick() { },
    /**
     * @description 看是否有選到該規格
     */
    selectedSpecFunc(index, innerIndex) {
      try {
        const clickIndex = `f${index}p${innerIndex}`
        if (!this.selectedIndexSpecArr.includes(clickIndex)) {
          return false
        } else {
          return true
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 加入商品到訂單之中
     */
    addToGoodsList() {
      this.$emit('addSelectedGoods', this.computedPetSizesPrice)
      this.selectedIndexSpecArr = []
      this.addGoodsDialogShowStatus = false
    },
    /**
     * @description 改變數量要做的事情
     */
    handleChange() { },
    /**
     * @description 返回類別
     */
    backToCategory() {
      let trueKey = ''
      for (const key in this.showControl) {
        if (this.showControl[key]) {
          trueKey = key
        }
      }
      this.setShowControlFalse()
      // 如果有找到true，則繼續走
      if (trueKey.length > 0) {
        const match = trueKey.match(/category(\d+)/)
        if (match) {
          // 提取的数字位于匹配结果的第一个捕获组中
          const number = parseInt(match[1], 10) - 1
          if (number > 0) {
            this.$set(this.showControl, `category${number}`, true)
          }
        } else {
        }
      }
    },
    handleClick() { },

    /**
     * @description 開窗
     */
    toPopWindow() {
      this.addGoodsDialogShowStatus = true
    },
    /**
     * @description 設定要顯示的是哪個
     */
    showControlFunc(cNumber) {
      for (const key in this.showControl) {
        // 如果傳進來的cNumber相等，則代表要顯示這個
        if (key === cNumber) {
          this.$set(this.showControl, key, true)
        } else {
          // 其他false
          this.$set(this.showControl, key, false)
        }
      }
    },
    setShowControlFalse() {
      for (const key in this.showControl) {
        // 如果傳進來的cNumber相等，則代表要顯示這個
        this.$set(this.showControl, key, false)
      }
    },
  },
}
</script>

<style lang="scss" module>
.centerText {
  display: flex;
  justify-content: center;
}

.imgHeight {
  height: 93px;
}

.subTitleDisplay {
  display: flex;
  flex-direction: row;
  align-items: center;

  >span {
    margin-right: 20px;
  }
}

.btnNoStyle {
  border: none;
  background-color: transparent;

  &:hover,
  &:focus {
    background-color: transparent;
  }
}

.wrapper {
  position: relative;
  height: 100%;
}

.table {
  padding: 20px 30px 0;
  display: flex;
  flex-direction: column;
  height: 100%;

  @include touch {
    padding-bottom: 30px;
  }

  @include max-md {
    padding: 20px;
  }

  :global {
    .el-tabs__active-bar {
      background-color: $color-primary !important;
    }

    .el-icon-back {
      font-size: 18px;
      color: $color-secondary;
    }

    .el-page-header__title {
      font-size: 18px;
      color: $color-secondary;
    }
  }
}

.categoryDivDisplay {
  display: flex;
  flex-wrap: wrap;

  :global {
    .categoryDiv {
      flex: 1;
      /* 自動平均分配寬度 */
      max-width: calc(50% - 20px);
      /* 50% 寬度减去 padding */
      min-width: calc(50% - 20px);
      /* 50% 寬度减去 padding */
      height: 175px;
      border: 1px solid #ccc;
      padding: 10px;
      border-radius: $border-radius;
      text-align: center;
      margin: 10px;
      background-color: white;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .categoryDivForThree {
      flex: 1;
      /* 自動平均分配寬度 */
      max-width: calc(33% - 20px);
      /* 33% 寬度减去 padding */
      min-width: calc(33% - 20px);
      /* 33% 寬度减去 padding */
      height: 210px;
      border: 1px solid #ccc;
      border-radius: $border-radius;
      text-align: center;
      margin: 10px;
      background-color: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;

      :global {
        .img {
          border-radius: 8px 8px 0 0;
        }

        .textDisplay {
          padding-left: 10px;
          align-self: flex-start; // 自己（為子元素）的flex排版
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          padding-top: 6px;
          padding-bottom: 6px;

          p {
            font-size: 12px;
            margin-top: 4px;
            margin-bottom: 4px;
          }

          .title {
            color: $color-secondary;
          }

          .subTitle {}

          .price {
            color: $color-primary;
          }
        }
      }
    }
  }
}

.innerTable {
  display: flex;
  flex-direction: column;
  height: 100%;

  @include touch {
    padding-bottom: 30px;
  }

  @include max-md {
    padding: 20px;
  }
}

.innerWrapper {
  position: relative;
  height: 100%;
}

.table {
  padding: 20px 30px 0;
  display: flex;
  flex-direction: column;
  height: 100%;

  @include touch {
    padding-bottom: 30px;
  }

  @include max-md {
    padding: 20px;
  }
}

.goodsListClass {
  display: flex;

  :global {
    .el-button {
      margin-right: 20px;
    }
  }
}

.specDetailDisplay {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: auto;
  overflow-x: auto;
  cursor: pointer;

  /* 使用overflow-x来控制横向滚动 */
  &__innerDiv {
    margin-right: 12px;
    width: 145px;
    min-width: 145px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #c0c4cc;
    border-radius: $border-radius;
    padding: 10px;

    p {
      width: 100%;
      text-align: center;
      text-overflow: ellipsis;
      white-space: wrap;
      line-height: 18px;
    }
  }
}

.counter {
  :global {
    .el-input-number {
      width: 100%;
    }

    .el-input-number__decrease {
      height: 96%;
      border-bottom-left-radius: 8px;
      border-top-left-radius: 8px;
    }

    .el-input-number__increase {
      height: 96%;
      border-bottom-right-radius: 8px;
      border-top-right-radius: 8px;
    }
  }
}

.selectedSpec {
  border: 1px solid $color-primary;
  color: $color-primary;
}

.commodityTopLeftBtn {
  display: flex;
  justify-content: flex-start;

  &__select {
    width: 160px;

    :global {
      .el-input .el-input__inner {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }

  &__input {
    width: 286.5px;

    :global {
      .el-input__inner {
        border-radius: 0;
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
        border-top-right-radius: 8px !important;
        border-bottom-right-radius: 8px !important;
      }
    }
  }
}
</style>
